import React, { Fragment, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";

// Contexts
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";

// Components
import LineItems from "./LineItems";
import TrackingForm from "./TrackingForm";

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginBottom: "0.4rem",
  },
  headerBox: {
    fontSize: "0.9rem",
  },
  lineItemBox: {
    color: theme.palette.text.secondary,
    minHeight: "3.5rem",
    fontSize: "0.9rem",
    width: "55rem",
  },
  lineItemControl: {
    width: "100%",
  },
  divider: {
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  },
  contentDivider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  image: {
    width: 50,
    border: "1px solid whitesmoke",
  },
  textField: {
    paddingRight: theme.spacing(1),
  },
  dialogActions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  button: {
    textTransform: "none",
  },
  errorMessages: {
    fontSize: "0.7rem",
    backgroundColor: "#FFE4E1",
    border: "2px solid red",
    padding: "0.5rem 0 0.5rem 1rem",
    marginBottom: "1rem",
  },
}));

const OrderFulfillment = ({
  handleClose,
  getImage,
  unfulfilledItems,
  products,
}) => {
  const classes = useStyles();

  const {
    modalFunction,
    modalValues,
    modalErrors,
    modalStates,
    setValues,
    setErrors,
    setModalStates,
    order,
    createOrderFulfillment,
  } = useContext(OrderContext);

  const onSubmit = (e) => {
    e.preventDefault();

    const new_errors = Object.assign({}, modalErrors);

    let valid_select = false;

    // Validation - values
    let select_item_id = [];

    // Check if any item is selected to fulfill
    Object.entries(modalValues.select_items).map(([key, val]) => {
      if (val) {
        select_item_id.push(parseInt(key));
        valid_select = true;
      }
    });

    if (!valid_select) {
      new_errors["line_items"] = "Select at least one item to proceed.";
    } else {
      new_errors["line_items"] = null;
      valid_select = true;
    }

    setErrors(new_errors);

    if (valid_select) {
      setModalStates({
        submitted: true,
        changed: true,
      });

      let line_items = [];
      let full_line_items = [];

      // Remove maxQty in line_items
      modalValues.line_items.map((each) => {
        if (select_item_id.includes(each.id)) {
          delete each.maxQty;
          line_items.push(each);
        }
      });

      // Get full lime items for manual update
      order.line_items.map((each) => {
        if (select_item_id.includes(each.id)) {
          line_items.map((items) => {
            if (items.id === each.id) {
              each.quantity = items.quantity;
            }
          });

          full_line_items.push(each);
        }
      });

      createOrderFulfillment(order.id, order.store_name, full_line_items, {
        line_items: line_items,
        notify_customer: modalValues.notify_customer,
        tracking_company: modalValues.tracking_company,
        tracking_number: modalValues.tracking_number,
      });
    }
  };

  useEffect(() => {
    if (modalFunction === "fulfillment") {
      let line_items = [];
      let select_items = {};

      unfulfilledItems.map((each) => {
        line_items.push({
          id: each.id,
          quantity: each.quantity,
          maxQty: each.quantity,
        });
        select_items[each.id] = false;
      });

      setValues({
        tracking_number: null,
        tracking_company: "China Post",
        line_items,
        select_items,
        notify_customer: true,
      });
      setErrors({
        tracking_number: null,
        tracking_company: null,
        line_items: null,
        select_items: null,
      });
    }
  }, [modalFunction]);

  return (
    modalFunction === "fulfillment" && (
      <Fragment>
        <DialogTitle> Mark as fulfilled </DialogTitle>
        <DialogContent dividers>
          <LineItems
            classes={classes}
            unfulfilledItems={unfulfilledItems}
            products={products}
            getImage={getImage}
          />
          <TrackingForm classes={classes} />{" "}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onSubmit}
            disabled={modalStates.submitted}
          >
            Fulfill items{" "}
          </Button>{" "}
          <Button
            variant="contained"
            className={classes.button}
            onClick={handleClose}
            disabled={modalStates.submitted}
          >
            Cancel{" "}
          </Button>{" "}
        </DialogActions>{" "}
      </Fragment>
    )
  );
};

export default OrderFulfillment;
